<template>
  <v-app id="inspire" style="background: #f1f8e9;">

    <v-navigation-drawer
      v-model="drawer"
      width="300"
      fixed
      clipped
      app
      :mini-variant.sync="mini"
      :permanent="!$vuetify.breakpoint.mobile"
      color="#fffffb"
    >
      <v-list-item two-line class="px-2">
        <v-list-item-avatar color="primary lighten-1">
          <div class="white--text">{{abreviatura}}</div>
        </v-list-item-avatar>

        <v-list-item-content>
          <div>{{nombreOperador}}</div>
        </v-list-item-content>

        <v-btn
          icon
          @click.stop="minimizar"
        >
          <v-icon>mdi-chevron-left</v-icon>
        </v-btn>
      </v-list-item>
      <v-list nav dense class="py-0">
        <v-list-item v-if="$vuetify.breakpoint.mobile">
          <v-list-item-title><fh-acceso-anterior :mobile="true"/></v-list-item-title>
        </v-list-item>
      </v-list>

      <v-divider></v-divider>

      <v-list nav dense>
        <v-list-item
          v-for="([icon, text, to], index) in links"
          :key="index"
          link
          :disabled="checkDisabled(index)"
          :to="{name: to}"
          color="primary"
        >
          <v-list-item-icon>
            <v-icon>{{ icon }}</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>
              <v-badge
                class="mt-0"
                inline v-if="to === 'Mis Turnos' && listaMisTurnos.length !== 0"
                :content="listaMisTurnos.length"
                :value="listaMisTurnos.length"
                color="primary"
              >
                {{ text }}
              </v-badge>
              <template v-else>{{ text }}</template>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>

      <v-divider></v-divider>

      <fh-desktop-filter v-if="!mini && !$vuetify.breakpoint.mobile && $route.name === 'Turnos disponibles'" :key="filterkey"/>
    </v-navigation-drawer>

    <v-app-bar
      app
      dense
      clipped-left
      clipped-right
      extended
      extension-height="0"
      elevation="0"
      class="grad"
    >
      <v-app-bar-nav-icon  class="white--text" @click="drawer = !drawer; $vuetify.breakpoint.mobile ? mini = false : mini = !mini"></v-app-bar-nav-icon>
      <img class="ml-1 mr-4 fh-pointer" src="@/assets/Hospital_Fil.png" @click="homeClick()" alt="Logo" height="35px" width="35px" />
      <v-toolbar-title>
        <router-link :to="{ name: 'Turnos disponibles' }" class="fh-link white--text">
          Hospital Filadelfia
        </router-link>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items>
        <fh-menu-operador :drawer="false"/>
      </v-toolbar-items>
      
      
      <fh-progress slot="extension"></fh-progress>
    </v-app-bar>

    <v-main>
      <fh-acceso-anterior/>
      <fh-mobile-filter v-if="$vuetify.breakpoint.mobile && $route.name === 'Turnos disponibles'" :key="filterkey"/>
      <v-container
        class="pb-8 px-6"
        fluid
      >
        <v-row>
          <router-view/>
        </v-row>
      </v-container>
    </v-main>

    <fh-snackbar></fh-snackbar>
  </v-app>
</template>

<script>
  import FhProgress from '@/components/app/FhProgress'
  import FhSnackbar from '@/components/app/FhSnackbar'
  import FhMobileFilter from '@/components/app/FhMobileFilter'
  import FhDesktopFilter from '@/components/app/FhDesktopFilter'
  import FhAccesoAnterior from '@/components/app/FhAccesoAnterior'
  import {mapState} from 'vuex'
  import SessionService from '@/services/SessionService'
  import FhMenuOperador from '@/components/app/FhMenuOperador.vue'



  export default {
    name: 'App',
    components: {FhSnackbar, FhProgress, FhMobileFilter, FhDesktopFilter, FhAccesoAnterior, FhMenuOperador},
    data: () => ({
      drawer: true,
      links: [
        ['mdi-checkbox-marked-circle-plus-outline', 'Reservar turno', 'Turnos disponibles'],
        ['mdi-calendar-check', 'Mis turnos','Mis Turnos'],
        ['mdi-badge-account-outline', 'Pacientes','Pacientes'],
      ],
      mini: false,
      filterkey: 1
    }),
    watch:{
      listaMisTurnos:{
        handler(){
          this.filterkey += 1
        },
        immediate:true,
        deep:true
      }
    },
    computed: {
      ...mapState('session', [
        'isRestored',
      ]),
      ...mapState('parametro', [
        'listaPacientes',
      ]),
      ...mapState('turnos',[
        'listaTurnos',
        'listaMisTurnos'
      ]),
      nombreOperador() {
        return SessionService.getNombreOperador()
      },
      abreviatura(){
        let words = this.nombreOperador.split(' ')
        let abr = ''
        if(words.length <= 3 && words.length >= 2){
          abr = `${words[0][0]}${words[1][0]}`
        }else{
          abr = `${words[0][0]}${words[2][0]}`
        }
        return abr
      }
    },
    methods: {
      minimizar(){
        if(this.$vuetify.breakpoint.mobile){
          this.drawer = false
        }else{
          this.mini = !this.mini
        }
      },
      checkDisabled(index){
        return index !== 2 && this.listaPacientes.length === 0
      },
      homeClick(){
        // eslint-disable-next-line no-unused-vars
        this.$router.push({name: 'Turnos disponibles'}).then().catch((e)=>{})
      }
    },
    async created() {

      while (!this.isRestored) {
        await this.$sleep(10)
      }

    },
  }
</script>

<style scoped>
  .grad {
    background-color: #1F3B76; /* For browsers that do not support gradients */
    background-image: linear-gradient(to bottom right, #1F3B76, #009a4e);
  }

  .fh-link {
    text-decoration: none;
  }

  .fh-pointer {
    cursor: pointer;
  }
</style>